import { render } from "./supportheader.vue?vue&type=template&id=5ffea515"
import script from "./supportheader.vue?vue&type=script&lang=js"
export * from "./supportheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__